module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAYAAAAi2ky3AAAAAXNSR0IArs4c6QAAAONJREFUOE9j9PYNbP3HwFDKyMDAykAG+M/A8JuJgaGb0dM38Be5hsDsBRnGSIYjsGph9PIN/E8Nw2hm0DfGf4yRXFzMO759++vxn+n/cgYGBi6Yi99zsHAdX736O4xvGRrKKfjjzzcQH9VF/xlmbNuyPhOm0MsncDoDI0MGMV4nySAMF1mGcgqKYHMRAwNer+FzGbbABsUiKFnAaLh+olz0////zX+Y/mVw/P//6w8DqwoLw+87PxgZ2Vj+Mc1gZGT0JRROcBf9Y/yrv2PTpkvoGjz8/PSY/jNfJGgQ1bIItTItACixcMzhMwwQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/reg/images/tag.png
// module id = VgzN
// module chunks = 1